import { ref } from 'vue';
import { getFromLocalStorage, saveInLocalStorage } from '@/utils/local-storage';

/**
 * Dual-currency helper: revenue is shown in EUR, expenses in MAD.
 * The EUR -> MAD rate is editable and persisted per browser.
 */
const RATE_KEY = 'eur_mad_rate';
export const DEFAULT_RATE = 10.87;

const saved = Number(getFromLocalStorage(RATE_KEY));
// Shared module-level ref so every component reacts to rate changes.
const rate = ref(saved && saved > 0 ? saved : DEFAULT_RATE);

function setRate(value) {
    const n = Number(value);
    if (n && n > 0) {
        rate.value = n;
        saveInLocalStorage(RATE_KEY, n);
    }
}

const fmt = (value) =>
    Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function useCurrency() {
    // Revenue (EUR) and expenses (MAD).
    const eur = (value) => `€${fmt(value)}`;
    const mad = (value) => `${fmt(value)} MAD`;

    // Conversions using the current rate.
    const madToEur = (value) => Number(value || 0) / rate.value;
    const eurToMad = (value) => Number(value || 0) * rate.value;

    return { rate, setRate, eur, mad, madToEur, eurToMad, DEFAULT_RATE };
}

export default useCurrency;
